import { Dispatch, FC, SetStateAction } from 'react';

import { EntityRole, EntityTeamLegalRole } from '@/api/entity/types';
import { EMAIL_REGEX } from '@/constants/static';
import { entityRoleList, isDirectorList } from '@/pages/manage-team/common';
import { Input, Select } from '@/shared/design-system';

import { DIRECTOR_CHANGE_TOOLTIP } from '../team-member-copy';
import { TeamMemberFields } from '../team-member-fields.styled';
import { TeamMemberAddData } from './index';

interface TeamMemberAddFormProps {
  data: TeamMemberAddData;
  setData: Dispatch<SetStateAction<TeamMemberAddData>>;
  resError?: string;
}

const roleOptions = entityRoleList.map(({ label, value }) => ({ label, value }));
const directorOptions = isDirectorList.map(({ label, value }) => ({ label, value }));

export const TeamMemberAddForm: FC<TeamMemberAddFormProps> = ({ data, setData, resError }) => {
  const invalidEmail = !EMAIL_REGEX.test(data.email) && data.email.length > 1;
  const emailError = resError || (invalidEmail ? 'Invalid email' : undefined);

  return (
    <TeamMemberFields>
      <Input
        size="lg"
        label="Email"
        required
        placeholder="Enter email"
        value={data.email}
        state={emailError ? 'destructive' : undefined}
        helperText={emailError}
        onChange={(event) => setData((prev) => ({ ...prev, email: event.target.value }))}
      />

      <Select
        size="lg"
        label="Role"
        required
        placeholder="Select role"
        options={roleOptions}
        value={data.role || null}
        onChange={(role) => setData((prev) => ({ ...prev, role: role as EntityRole }))}
      />

      <Select
        size="lg"
        label="Director"
        required
        tooltip={DIRECTOR_CHANGE_TOOLTIP}
        placeholder="Select is this user a Director"
        options={directorOptions}
        value={data.legalRole || null}
        onChange={(legalRole) =>
          setData((prev) => ({ ...prev, legalRole: legalRole as EntityTeamLegalRole }))
        }
      />
    </TeamMemberFields>
  );
};
